module.exports = __webpack_public_path__ + "img/logo_color.9697593a.svg";